@if (
  files?.length === 0 &&
  filesDetails?.code !== 202 &&
  filesDetails?.code !== 404 &&
  fileListVisible
) {
  <div class="text-center text-muted u_margin-md-top u_margin-md-bottom">
    You haven't uploaded any files yet!
  </div>
}
@if (
  files?.length > 0 &&
  filesDetails?.code !== 202 &&
  filesDetails?.code !== 404 &&
  fileListVisible
) {
  <div
    #gridContainer
    id="storageFilesGrid"
    class="grid-selector-list grid-selector-list_storage grid-container"
  >
    @for (
      file of visibleFiles;
      track trackByFileName($index, file);
      let index = $index
    ) {
      <div
        (click)="fileClick.emit(file)"
        (keyup.enter)="fileClick.emit(file)"
        tabindex="0"
        [attr.aria-label]="
          (storageUtilsService.fileIsFolder(file.item)
            ? 'Enter folder'
            : 'Select file') +
            ' ' +
            file.item.name | storageFileName: folderPath
        "
        class="grid-selector-list-item"
        [class.selected]="file.selected"
        [class.folder]="storageUtilsService.fileIsFolder(file.item)"
        [class.first-file]="isFirstFile(file)"
        [matTooltip]="
          file.item.name
            | storageFileName
              : folderPath +
                  (isThrottled(file)
                    ? ' - This file is being requested too many times and is blocked.'
                    : '')
        "
        [style.height]="
          storageUtilsService.fileIsFolder(file.item) ? '52px' : '186px'
        "
        [rvDraggableItem]="file.item"
        [dragNotAllowed]="
          !storageFull ||
          isTrashFolder ||
          !storageService.canSelect(
            file,
            storageFull,
            selectorType,
            selectorFilter
          )
        "
        [rvDroppableItem]="file.item"
        [dropNotAllowed]="!storageUtilsService.fileIsFolder(file.item)"
      >
        <thumbnail-image
          [file]="file"
          [folderPath]="folderPath"
          [index]="index"
          (fileSelect)="fileSelect.emit(file)"
          [selectorType]="selectorType"
          [selectorFilter]="selectorFilter"
          [storageFull]="storageFull"
          class="draggable-mirror-content"
        ></thumbnail-image>
        @if (!storageUtilsService.fileIsTrash(file.item)) {
          <div
            class="menu-container"
            [class.folder]="storageUtilsService.fileIsFolder(file.item)"
            [class.menu-is-open]="
              operationsMenu.matMenuTrigger?.menuOpen ?? false
            "
          >
            <operations-menu
              #operationsMenu
              [operations]="listOperations"
              id="file-operations-menu-{{ index + 1 }}"
              (operationClick)="
                operationClick.emit({ file, operationName: $event })
              "
            />
          </div>
        }
      </div>
    }
  </div>
}
@if (isEmpty) {
  <empty-state
    [search]="search"
    [isMultipleFilesFoldersSelector]="
      storageService.isMultipleFilesFoldersSelector(selectorType)
    "
    (uploadFiles)="uploadFiles.emit()"
  />
}
